import { render, staticRenderFns } from "./patient-fusion-data.vue?vue&type=template&id=383e8a8a&scoped=true&"
import script from "./patient-fusion-data.ts?vue&type=script&lang=ts&"
export * from "./patient-fusion-data.ts?vue&type=script&lang=ts&"
import style0 from "./patient-fusion-data.scss?vue&type=style&index=0&id=383e8a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e8a8a",
  null
  
)

export default component.exports